const Politic = () => {
  return (
    <div className='max-w-[1280px] mx-auto p-32 space-y-32'>
      <h1 className='text-center font-bold'>POLITIQUE DE CONFIDENTIALITÉ</h1>
      <p>
        La société EDPREF (dénommée ci-après sous son nom commercial « CLAP.TECH
        ») est la société titulaire de la plateforme clap.show disponible sur le
        site <a href='https://clap.show'>https://clap.show</a> (ci-après le « <b>Site</b> »).
      </p>
      <p>
        Dans le cadre de l’utilisation du Site, les utilisateurs (ci-après les «
        <b>Utilisateurs</b> ») sont amenés à communiquer des données à caractère
        personnel les concernant.
      </p>
      <p>
        CLAP.TECH, responsable de traitement, accorde la plus grande importance
        à la confidentialité et la sécurité de ces données personnelles. Cette
        politique de confidentialité (ci-après la « <b>Politique de Confidentialité</b>
        ») a été fondée dans le respect des lois, règlements et normes en
        vigueur et explique quelles sont les données personnelles concernées,
        comment elles sont collectées, traitées, diffusées et conservées, et à
        quelles fins.
      </p>
      <p>
        Les données personnelles collectées par CLAP.TECH) dépendent de votre
        utilisation du Site et peuvent inclure des données personnelles que vous
        avez communiquées :
      </p>
      <p>
        CLAP.TECH veille à collecter et traiter les données strictement
        nécessaires à la finalité de réalisation d’une commande, décrite à
        l’Article 2 de la présente Politique de Confidentialité. Elles
        concernent :
      </p>
      <h2 className='font-bold'>1 –DONNÉES COLLECTÉES ET FINALITÉS DES TRAITEMENTS</h2>
      <h3 className='underline font-bold'>1.1. Données personnelles :</h3>
      <p>
        Les traitements mis en œuvre par CLAP.TECH répondent à une finalité
        explicite, légitime et déterminée. Les données sont traitées
        principalement pour les finalités suivantes :
      </p>
      <table className='border border-greyLight7 border-collapse table-border	'>
        <thead>
          <tr>
            <th>Catégorie d’informations collectées</th>
            <th>Informations collectées</th>
            <th>Finalités</th>
            <th>Base légale</th>
            <th>Durée</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Données liées à un compte client</td>
            <td>
              <ul>
                <li>- adresse mail</li>
                <li>- numéro de téléphone</li>
                <li>- poste de travail</li>
                <li>- identifiant /mdp</li>
              </ul>
            </td>
            <td>- Passer commande et gestion de la relation client</td>
            <td>- contrat</td>
            <td>5 ans à compter de la cessation de la relation</td>
          </tr>
          <tr>
            <td>
              Données liées à une newsletter et envoi de courriers/mails
              commerciaux
            </td>
            <td>Informations</td>
            <td></td>
            <td></td>
            <td>3 ans à compter de la dernière activité</td>
          </tr>
          <tr>
            <td>Données liées au paiement</td>
            <td>
              <ul>
                <li>- numéro cartes bancaires</li>
                <li>- données bancaires</li>
              </ul>
            </td>
            <td>Pour procéder au paiement</td>
            <td>contrat</td>
            <td>
              Les données sont conservées pour les besoins du paiement en
              reconduction tacite du contrat souscrit
            </td>
          </tr>
          <tr>
            <td>Partage de données au sein du groupe CLAP.TECH</td>
            <td>
              - données compte clients (adresse mail, contrats, mode de
              paiement, préférence, …)
            </td>
            <td>- connaissance client</td>
            <td>Intérêt légitime</td>
            <td>5 ans à compter de la dernière activité</td>
          </tr>
          <tr>
            <td>Statistique données</td>
            <td>- données compte clients et données navigation</td>
            <td>- amélioration service et de la solution</td>
            <td>Intérêt légitime</td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <p>
        Les données personnelles ne sont en aucun cas cédées à un tiers à des
        fins commerciales.
      </p>
      <h3 className='underline font-bold'>1.2. Cookies :</h3>
      <div className='space-y-12'>
        <p>
          Le Site utilise plusieurs types de Cookies répondant à différentes
          finalités :
        </p>
        <ul className='list-disc pl-48 space-y-12'>
          <li>
            Cookies de fonctionnalité : Indispensables à l’utilisation du Site,
            ils permettent d’utiliser les fonctionnalités principales du Site le
            maintien de l’identification tout au long de la navigation,
            l’adaptation de la présentation du Site aux préférences d’affichage
            du terminal Utilisateur, la gestion et l’accès de manière sécurisée
            à l’espace personnel de l’Utilisateur etc. Ces Cookies sont
            nécessaires à la fourniture des services lors de la navigation sur
            le Site. Ces Cookies de fonctionnalité ne peuvent pas être
            désactivés, le Site ne pouvant pas fonctionner correctement sans ces
            Cookies.
          </li>
          <li>
            Cookies analytiques et de mesure d’audience : Il s'agit des Cookies
            non individualisés qui permettent de mieux connaître l'utilisation
            (par exemple, les pages le plus souvent consultées) et les
            performances du Site afin d'en améliorer le fonctionnement. Ces
            Cookies peuvent être installés sur l’ordinateur de l’Utilisateur par
            le Responsable de traitement ou par ses prestataires et partenaires
            de mesure d’audience. Ces Cookies ne sont pas indispensables à la
            navigation mais permettent de mesurer les performances du Site, de
            détecter des problèmes de navigation, de faciliter les recherches,
            d'analyser les contenus consultés, ou encore d’optimiser le
            fonctionnement du Site.
          </li>
          <li>
            Cookies de personnalisation : Ils permettent de visiter le Site de
            manière personnalisée, en fonction des anciennes visites, des
            achats, etc.
          </li>
        </ul>
        <p>
          Il est considéré que l’Utilisateur a donné son accord au dépôt des
          cookies, si l’Utilisateur a poursuivi sa navigation en cliquant sur le
          bouton « Ok, tout accepter » du bandeau l’informant de l’utilisation
          de Cookies, ou sur un élément du Site tel qu’une image, un titre, un
          bouton etc., ou en se rendant sur toute autre page que la page par
          laquelle il a accédé à l’un des Sites lors de sa première connexion.
          Cet accord n’est valable que pour une durée de treize (13) mois à
          compter du premier dépôt de cookie. Une fois ce délai dépassé,
          l’accord sera redemandé pour l’utilisation de ces cookies.
        </p>
      </div>
      <div className='border border-grey p-12 space-y-12'>
        <p>
          Vous pouvez à tout moment choisir de vous opposer ou de limiter
          l’enregistrement des Cookies en configurant votre logiciel de
          navigation (Internet Explorer, Google Chrome, Safari, Firefox, etc.)
          et dans la mesure où votre terminal est susceptible de visualiser des
          contenus développés avec le langage Flash, vous pouvez accéder à vos
          outils de gestion des Cookies Flash.
        </p>
        <p>
          Votre navigateur peut être paramétré pour vous signaler les Cookies
          qui sont déposés dans votre ordinateur et vous demander de les
          accepter ou non. Vous pouvez accepter ou refuser les Cookies au cas
          par cas ou bien les refuser systématiquement.
        </p>
        <p>
          Attention, il est possible que cette configuration de votre navigateur
          vous prive d’accéder à certains contenus ou perturbe significativement
          votre navigation et les services que vous attendez de la part de notre
          Site. Le cas échéant, nous déclinons toute responsabilité pour les
          conséquences liées au comportement dégradé de notre Site résultant de
          l'impossibilité d’utiliser les Cookies nécessaires à son
          fonctionnement. Si votre navigateur est configuré de manière à refuser
          l'ensemble des Cookies, vous ne pourrez pas effectuer d'achats ou
          profiter de fonctions essentielles de notre Site, comme par exemple
          stocker des articles dans votre panier ou recevoir des recommandations
          personnalisées.
        </p>
        <p>
          Afin de gérer les Cookies au plus près de vos attentes nous vous
          invitons à paramétrer votre navigateur en tenant compte de la finalité
          des Cookies telle que mentionnée ci-avant.
        </p>
        <p>
          La configuration de chaque navigateur est différente. Elle est décrite
          dans le menu d'aide de votre navigateur, qui vous permettra de savoir
          de quelle manière modifier vos souhaits en matière de Cookies.
          Celle-ci vous indique comment refuser les nouveaux Cookies ou obtenir
          un message qui vous signale leur réception ou encore comment
          désactiver les Cookies, soit systématiquement, soit selon leur
          émetteur. Vous pouvez également effacer les Cookies manuellement.
        </p>
      </div>
      <p className='text-lg font-bold'>
        Pour plus d’informations sur l’utilisation, la gestion et la suppression
        des « cookies », pour tout type de navigateur, il convient de consulter
        le lien suivant :{' '}
        <a
          href={'https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser'}
          className='underline'
        >
          https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser
        </a>
      </p>
      <h2 className='font-bold'>2 - DESTINATAIRES</h2>
      <p>
        Les données peuvent faire l’objet d’un recueil ou d’une transmission, et
        d’un traitement par un tiers au nom et pour le compte de CLAP.TECH dans
        la stricte limite des motifs précités à l’Article 2.
      </p>
      <p>
        Dans cette hypothèse, CLAP.TECH s’assure que tous les prestataires avec
        lesquels elle travaille préservent la confidentialité et la sécurité des
        données. CLAP.TECH peut par exemple, demander de fournir des services
        qui nécessitent le traitement des données à caractère personnel de ses
        Utilisateurs à des :
      </p>
      <ul className='pl-48 list-disc space-y-12'>
        <li>
          Sous-traitants : structures partenaires qui réalisent une partie de la
          prestation, services informatiques tels que services de maintenance et
          de support technique pour les bases de données ainsi que pour les
          logiciels et applications qui peuvent contenir des données concernant
          les Utilisateurs ou prospects de CLAP.TECH, Agences marketing et / ou
          web qui réalisent le site internet, les campagnes publicitaires,
          marketing et commerciales de CLAP.TECH.
        </li>
        <li>
          Destinataires ou responsables conjoints de traitement : avocat,
          auditeur, expert-comptable, etc., autorités publiques compétentes à
          leur demande.
        </li>
      </ul>
      <h2 className='font-bold'>3 - DURÉE LIMITÉE</h2>
      <p>
        Il est rappelé que dès lors qu’une donnée n’est plus utile et ni soumise
        à conservation légale, elle est supprimée.
      </p>
      <p>Tout archivage est assuré sous cryptage et chiffrement sécurisé.</p>
      <h2 className='font-bold'>4 - TRANSFERT DES DONNÉES PERSONNELLES A L’ÉTRANGER</h2>
      <p>Les données traitées sont hébergées chez AWS, en Union Européenne. </p>
      <p>
        CLAP.TECH n’effectue pas de transfert de données en dehors de l’Union
        Européenne.
      </p>
      <h2 className='font-bold'>5 - SÉCURITÉ ET CONFIDENTIALITÉ</h2>
      <p>
        CLAP.TECH met en œuvre des mesures organisationnelles, techniques,
        logicielles en matière de sécurité physique et informatique pour
        protéger les données personnelles contre les altérations, destructions
        et accès non autorisés.
      </p>
      <p>
        Le respect de la confidentialité et de la protection des données
        s’impose à l’ensemble des collaborateurs, prestataires et sous-traitants
        de CLAP.TECH.
      </p>
      <h2 className='font-bold'>6 – DROIT DES UTILISATEURS</h2>
      <p>
        En application de la réglementation applicable aux données à caractère
        personnel les Utilisateurs disposent des droits suivants :
      </p>
      <ul className='pl-48 list-disc space-y-12'>
        <li>
          Droit d’accès et de rectification des données personnelles les
          concernant. Dans ce cas, avant la mise en œuvre de ce droit, CLAP.TECH
          peut demander une preuve de l’identité de l’Utilisateur afin d’en
          vérifier l’exactitude.
        </li>
        <li>
          Le droit pour l’Utilisateur de retirer son consentement à tout moment
          au traitement de ses données personnelles, pour les traitements
          effectués sur cette base.
        </li>
        <li>
          Droit de demander la suppression des données personnelles. Néanmoins,
          les données nécessaires au respect d’une obligation légale s’imposant
          au Responsable de traitement ne pourront être supprimée. En outre, les
          données nécessaires à l’exécution du contrat seront supprimées à
          l’expiration du délai de préavis de trente (30) jours, la demande de
          suppression des données entrainant l’impossibilité pour CLAP.TECH de
          satisfaire à l’exécution du Contrat.
        </li>
        <li>
          Opposition au traitement de leurs données personnelles, pour motif
          légitime. L’Utilisateur est conscient que l’exercice de ce droit
          d’opposition peut conduire à l’impossibilité pour CLAP.TECH d’exécuter
          tout ou partie de la commande quand ce droit est exercé sur des
          données nécessaires à l’exécution de celle-ci.
        </li>
        <li>
          Limitation du traitement, permettant à l’Utilisateur de geler
          temporairement l’utilisations de certaines de ses données personnelles
          par CLAP.TECH.
        </li>
        <li>
          Portabilité de ses données. Conformément à l’article 20 du règlement
          européen n°2016/679 dit « RGPD », la personne concernée dispose du
          droit de recevoir les données à caractère personnel la concernant
          qu'elle a fournies à CLAP.TECH, dans un format structuré, couramment
          utilisé et lisible par machine, et a le droit de transmettre ces
          données à un autre responsable du traitement sans que CLAP.TECH,
          auquel les données à caractère personnel ont été communiquées, y fasse
          obstacle.
        </li>
        <li>
          L’Utilisateur peut enfin définir le sort de ses données après sa mort
          et choisir que CLAP.TECH communique (ou non) ces données à un tiers
          qu’il aura préalablement désigné. En cas de décès et à défaut
          d’instructions de sa part, CLAP.TECH s’engage à détruire ces données,
          sauf si leur conservation s’avère nécessaire à des fins probatoires ou
          pour répondre à une obligation légale.
        </li>
      </ul>
      <p>
        Les droits relatifs au RGPD peuvent être exercés par courrier ou
        courriel auprès de :
      </p>
      <div className='text-center font-medium'>
        <p>EDPREF</p>
        <p>CLAP.TECH données personnelles</p>
        <p>545 avenue de l’Europe – 38330 MONTBONNOT-SAINT-MARTIN</p>
        <p>Email : contact@clap.tech</p>
      </div>
      <p>
        Si vous estimez après nous avoir contactés, que vos droits «
        Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
        une réclamation aux services de la CNIL.
      </p>
      <h2 className='font-bold'>7 – ÉVOLUTION DE LA POLITIQUE DE CONFIDENTIALITÉ</h2>
      <p>
        CLAP.TECH se réserve le droit d’apporter toute modification ou mise à
        jour à la présente Politique à tout moment et sans préavis.
      </p>
    </div>
  )
}

export default Politic
